<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
            	<div class="col-12 mt-4 mb-4 redeem-voucher">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <img class="img-fluid" v-bind:src="'/img/logo-white.png'"  width="150" alt="Gifted PH" title="Gifted PH" />
                                </div>
                                <div class="col-md-6">
                                    <h1 class="title">Gift Card</h1>
                                </div>

                            </div>
                        </div>
                        <div class="card card-title">
                            <h3>Your link has changed!</h3>
                        </div>
                        <div class="card-body">
                            <p>We have made some improvements to your link. Everything else stays the same, we have sent it again to your email address. Please check and claim your Gift Card.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .swal2-select{
        margin: 0 auto;
        width: 100%;
        max-width: 265px;
        border-radius: 5px;
        -moz-appearance:none; /* Firefox */
        -webkit-appearance:none; /* Safari and Chrome */
        appearance:none;
        background: url('/img/dropdown-arrow.png') no-repeat right center;
        background-size: contain;
    }
    .swal2-select:focus{
        border: 1px solid #DE3C4C;
        outline: none;
    }
    .swal2-validation-message{
        background-color: transparent;
    }
</style>
<style scoped>
    .redeem-voucher{
        max-width: 500px;
        margin: 0 auto;
    }
    .redeem-voucher .card-header{
        background-color: #DE3C4C;
    }
    .redeem-voucher .card-header .title{
        font-size: 30px;
        color: #fff;
        text-align: right;
        margin: 0 auto;
        padding: 8px 0;

    }
    .redeem-voucher .card-title{
        border: 0;
        margin: 0;
    }
    .redeem-voucher .card-title h3{
        text-align: center;
        padding: 15px;
        background-color: #eee;
        margin: 0;
    }
    .redeem-voucher table{
        margin: 0;
    }
    .redeem-voucher table tr:first-child td{
        border-top: 0;
    }
    .redeem-voucher button.btn-redeem{
        width: 100%;
        background-color: #DE3C4C;
        color: #fff;
        font-size: 20px;
        outline: 0;
        border: 0;
    }
    .redeem-voucher button.btn-redeem:hover, .redeem-voucher button.btn-redeem:focus{
        outline: 0;
        border: 0;
    }
    .btn-select-brand{
        display: block;
        color: rgb(255, 255, 255);
        background-color: rgb(222, 60, 76);
        border: 1px solid rgb(222, 60, 76);
        border-radius: 5px;
        cursor: pointer;
        text-decoration: none;
        font-size: 16px;
        font-weight: bold;
        padding: 6px 25px;
        text-transform: capitalize;
        width: 100%;
        max-width: 250px;
        margin: 0 auto;
    }

</style>
<script>
    import moment from 'moment'

    export default {
        props: ['resend_link'],
        data(){
            return {
                resend_link: ""
            }
        },
        mounted() {

            this.resend_link = this.resend_link;

        },
        methods: {
            check_system_email: function (orderNumber) {

                var recipientEmail;
                var recipientFirstname;
                var recipientLastname;

                Swal.mixin({
                  input: 'text',
                  backdrop: '#c6e3de',
                  confirmButtonText: 'Next &rarr;',
                  showCancelButton: true,
                  confirmButtonColor: '#DE3C4C',
                  cancelButtonColor: '#ccc',
                  progressSteps: ['1', '2', '3'],
                  allowOutsideClick: false,
                  allowEscapeKey: false
                }).queue([
                    {
                        title: 'Your Email Address',
                        preConfirm: function(value)
                        {
                            recipientEmail= value;
                            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                            if(value == ''){
                                Swal.showValidationMessage(
                                      `Email is required.`
                                    )
                            }else if (!re.test(value)){
                                Swal.showValidationMessage(
                                      `Valid email required.`
                                    )
                            }
                        }
                    },
                    {
                        title: 'Your First Name',
                        preConfirm: function(value)
                        {
                            recipientFirstname= value;
                            if(value == ''){
                                Swal.showValidationMessage(
                                      `First Name is required.`
                                    )
                            }
                        }
                    },
                    {
                        title: 'Your Last Name',
                        preConfirm: function(value)
                        {
                            recipientLastname= value;
                            if(value == ''){
                                Swal.showValidationMessage(
                                      `Last Name is required.`
                                    )
                            }
                        }
                    }
                ]).then((result) => {
                  if (result.value) {
                    const answers = JSON.stringify(result.value)
                    Swal.fire({
                        title: 'Recipient Details',
                        html:
                            '<h4>Email: ' + recipientEmail+
                            '</h4><h4>First Name: ' + recipientFirstname+
                            '</h4><h4>Last Name: ' + recipientLastname+
                            '</h4>',
                        confirmButtonColor: '#DE3C4C',
                        confirmButtonText: 'Confirm'
                    }).then((result) => {
                      if (result.isConfirmed) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Please wait!',
                            html: 'Saving your information...',
                            showConfirmButton: false,
                        });

                        $.ajax({
                            type: "POST",
                            url: "/api/ggc_update_order",
                            data: { 'orderNumber': orderNumber, 'recipientEmail': recipientEmail, 'recipientFirstname': recipientFirstname, 'recipientLastname': recipientLastname },
                            cache: false,
                        })
                        .then(response => {
                            console.log(response);
                            //return response;
                            const result = JSON.parse(response);

                            if(result.response.class == "success"){
                                Swal.fire({
                                  icon: result.response.class,
                                  title: result.response.message,
                                  html: '',
                                  showConfirmButton: false,
                                })

                                setTimeout(function () {
                                    location.reload();
                                }, 1500)
                            }else{
                                Swal.fire({
                                  icon: result.response.class,
                                  title: result.response.message,
                                  html: '',
                                  showConfirmButton: false,
                                })
                            }
                        })
                        .catch(error => {
                            Swal.showValidationMessage(
                              `Request failed! Please contact support.`
                            )
                        })
                      }
                    })
                  }
                });

            },
            redeem: function (orderNumber, products, is_system_email) {
                //alert(orderNumber);

                if(is_system_email == 1){
                    this.check_system_email(orderNumber)
                }else{

                    var productOptions = new Promise(function (resolve) {
                      setTimeout(function () {
                        resolve(products)
                      }, 500)
                    })
                    var productID;


                    Swal.fire({
                        title: 'Products Available',
                        showCancelButton: true,
                        confirmButtonText: 'Claim',
                        confirmButtonColor: '#DE3C4C',
                        showLoaderOnConfirm: true,
                        input: 'select',
                        inputOptions: productOptions,
                        background: '#fff',
                        backdrop: '#c6e3de',
                        preConfirm: (productID) => {

                            if(productID != 0){

                                Swal.fire({
                                  icon: 'warning',
                                  title: 'Please wait!',
                                  html: 'Your voucher is processing...',
                                  showConfirmButton: false,
                                })

                                $.ajax({
                                    type: "POST",
                                    url: "/api/ggc_redeem",
                                    data: { 'orderNumber': orderNumber, 'productID': productID},
                                    cache: false,
                                })
                                .then(response => {
                                    console.log(response);
                                    //return response;
                                    const result = JSON.parse(response);
                                    Swal.fire({
                                      icon: result.response.class,
                                      title: result.response.message,
                                      html: '',
                                      showConfirmButton: false,
                                      showConfirmButton: false,
                                    })

                                    setTimeout(function () {
                                        location.reload();
                                    }, 1500)
                                })
                                .catch(error => {
                                    Swal.showValidationMessage(
                                      `Request failed! Please contact support.`
                                    )
                                })


                            }else{
                                Swal.showValidationMessage('No product selected');
                            }
                        },
                        allowOutsideClick: () => !Swal.isLoading()
                    })
                }

            },
            validEmail: function (email) {
              var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return re.test(email);
            }
        },
        filters: {
          moment: function (date) {
            return moment(date).format('MMMM D, YYYY h:mm:ss A');
          }
        }
    }

</script>
